module.exports = __webpack_public_path__ + "img/logo-icon.af6b5e7f.png";